import React from 'react';
import List from 'components/AssetList';
import Header from 'components/AssetList/Header';
import { useToggle } from 'components/AssetList/hooks';
import TextComponentItem from 'components/TextComponentItem';
import * as Models from 'models';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

type Props = {
  components: Models.TextComponentsMap;
  isExpand?: boolean;
  showHeader: boolean;
  toggleExpand?(): void;
  dataTestId?: string;
};

const TextComponentList: React.FunctionComponent<Props> = (props) => {
  const { isExpand, components, showHeader, toggleExpand, dataTestId = 'textComponentList' } = props;
  const { expanded, toggle } = useToggle({
    isExpand,
    toggle: toggleExpand,
  });

  const renderHint = (): JSX.Element => (
    <div className={styles.hint} data-testid={`${dataTestId}-subheader`}>
      <div data-testid={`${dataTestId}-subheader-title`}>{intlGet('Assets', 'Text.Hint.Title')}</div>
      <div data-testid={`${dataTestId}-subheader-message`}>{intlGet('Assets', 'Text.Hint.Message')}</div>
    </div>
  );

  if (!components) {
    return null;
  }

  return (
    <div className={styles.TextComponentListContainer} data-title="text-components" data-testid={dataTestId}>
      {showHeader &&
        <Header
          title={intlGet('Assets', 'Text', { count: components.size })}
          expanded={expanded}
          onClick={toggle}
          dataTestId={`${dataTestId}-header`}
        />
      }
      {
        (expanded || !showHeader) &&
        <List
          border={showHeader}
          elements={components}
          subheader={components.size === 0 && renderHint()}
          renderElement={(component: Models.TextComponentMap, index: number): JSX.Element => (
            <TextComponentItem
              allowDelete={showHeader}
              key={component.get('id')}
              component={component}
              dataTestId={`${dataTestId}-list-item${index}`}
            />
          )}
          dataTestId={`${dataTestId}-list`}
        />
      }
    </div>
  );
};

export default TextComponentList;
